import AddAPhotoIcon from "@mui/icons-material/AddAPhoto"

import { Box } from "@mui/material"
import { StyledButton } from "components/Button/StyledButton"
import { CameraDialog } from "components/Camera/CameraDialog"
import { ImageSlider } from "components/ImageSlider/ImagesSlider"
import { File, FileType, FileUploadInput, User } from "graphql/types"
import { useStoreActions } from "hooks/storeHooks"
import { enqueueSnackbar } from "notistack"
import { FormEvent, useState } from "react"
import { emptyPerson } from "store/store"
import { useLocalStorage } from "utils/useLocalStorage"
import { v4 } from "uuid"

type TakeFotoBoxProps = {
  // eslint-disable-next-line no-unused-vars
  setImages: (data: File[]) => void
  images: File[]
  imageName?: string
}

export const TakeFotoBox = (props: TakeFotoBoxProps) => {
  const { setImages, images, imageName } = props

  const [user] = useLocalStorage<User>("user", emptyPerson)
  const [openFoto, setOpenFoto] = useState(false)

  const { uploadFile } = useStoreActions((actions) => actions)

  const handleSave = async (event: FormEvent<HTMLFormElement>, fotos: string[]) => {
    event.preventDefault()
    if (!fotos.length) {
      enqueueSnackbar("Kein Bild erfasst!", { variant: "error" })
      return
    }

    const formData = new FormData(event.currentTarget)
    const newImageInput: FileUploadInput = {
      id: "NEW",
      filename: v4() + ".png",
      name: formData.get("title") as string,
      description: (formData.get("description") as string) || undefined,
      base64: fotos[0],
      createdAt: new Date().toISOString(),
      createdBy: user.id,
      type: FileType.IMAGE,
    }

    const result = await uploadFile(newImageInput)

    const newImage: File = {
      id: result,
      createdAt: new Date().toISOString(),
      createdBy: user.id,
      fileURL: "",
      name: formData.get("title") as string,
      description: (formData.get("description") as string) || undefined,
      type: FileType.IMAGE,
      filename: newImageInput.filename,
    }
    setImages([...images, newImage])
  }

  const handleDeleteImage = (file: File) => {
    const filtered = images.filter((img) => img.id !== file.id)
    setImages(filtered)
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <StyledButton
          buttonType="custom"
          customIcon={<AddAPhotoIcon />}
          customText="Foto hinzufügen"
          onClick={() => setOpenFoto(true)}
        />

        {images && images.length > 0 && (
          <ImageSlider images={images} isDeletable onDelete={handleDeleteImage} />
        )}
      </Box>

      <CameraDialog
        open={openFoto}
        onClose={() => setOpenFoto(false)}
        onSave={handleSave}
        imageName={imageName}
      />
    </>
  )
}
